<template>
  <div class="messageManage">
    <div class="tab">
      <div class="tab-item " @click="goto()">提醒<span v-if="noticeNum!=0">{{`(${noticeNum})`}}</span></div>
      <div class="tab-item tab-active">消息<span v-if="msgNum!=0">{{`(${msgNum})`}}</span></div>
    </div>
    <div class="key_top">
      <ul class="key_list">
        <li class="conditions_list_item">
          <span>消息内容：</span>
          <el-input v-model="search.remindContent" placeholder="请输入消息内容" @input="pageNumber=1,queryMessages()">
          </el-input>
        </li>
        <li class="conditions_list_item">
          <span>类型</span>
          <el-select v-model="search.messageType" @change="pageNumber=1,queryMessages()" placeholder="不限" clearable>
            <el-option v-for="(item,index) in messageTypeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li class="conditions_list_item">
          <span>状态</span>
          <el-select v-model="search.status" @change="pageNumber=1,queryMessages()" placeholder="不限" clearable>
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <el-button @click="addEmployeeMessage" type="primary">已读</el-button>
      </ul>
    </div>

    <div class="key_list_wrap sales_list_wrap">
      <el-table :data="List" border style="width: 100%" @row-dblclick="msgDetailShow" @select-all="selectAll" @select="select" :header-cell-style="setHeaderStyle">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="content" width="700px" :show-overflow-tooltip="true" label="消息内容">
          <template slot-scope="scope">
            <div style="text-align:left">{{scope.row.content}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="detailId" label="业务编号">
          <template slot-scope="scope">
            <div style="color:#5e75e6;cursor:pointer;" @click="goDetail(scope.row)">{{scope.row.detailCode}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="messageType" label="类型"></el-table-column>
        <el-table-column prop="operationDate" label="发送时间"></el-table-column>
        <el-table-column prop="sendName" label="发送人"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
      </el-table>
      <div class="footer_page">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
      </div>
    </div>

    <el-dialog title="消息详情" :visible.sync="dialogVisible">
      <div class="leaveRequest_content">
        <div class="item">
          <div class="item_div">
            <span class="label">发件人：
            </span>
            {{form.sendName}}
          </div>
          <div class="item_div">
            <span class="label">发送时间：
            </span>
            {{form.operationDate}}
          </div>
        </div>
        <div class="item">
          <div class="item_div">
            <span class="label">内容：</span>
            {{form.content}}
          </div>
        </div>
      </div>
      <div class="dialog-foot">
        <button class="foot-save" v-if="pageIndex<(List.length-1) && List.length!=1" @click="nextPage">下一条</button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import {
  queryMessages,
  addEmployeeMessage,
  queryMessageNumberMessages,
} from "@/api/manageCenter";
import { dicGet } from "@/api/index";
export default {
  name: "/messageManage",
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    let date = new Date();
    return {
      permisList,
      noticeNum: 0,
      msgNum: 0,
      total: 0,
      currentPage: 1,
      pageNumber: 1, //从第几条开始
      pageSize: 20, //显示条数
      dialogVisible: false,
      // state: "不限", //状态
      List: [], //房源列表
      messageTypeList: [
        {
          label: "待办消息",
          value: "1",
        },
        {
          label: "预警消息",
          value: "2",
        },
        {
          label: "系统消息",
          value: "3",
        },
        {
          label: "匹配消息",
          value: "4",
        },
      ],
      typeList: [
        {
          label: "未读",
          value: "NO",
        },
        {
          label: "已读",
          value: "YES",
        },
      ],
      //搜索
      search: {
        remindContent: "", //提醒内容
        messageType: "", //类型
        status: "", //状态
        type: "message", //消息还是提醒
      },
      form: {
        sendName: "",
        operationDate: "",
        content: "",
        id: "",
      },

      ids: [],
      ids1: [],
      pageIndex: 0,
    };
  },
  components: {},
  mounted() {
    this.queryMessages();
    this.queryMessageNumberMessages();
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      console.log(23432343423, result);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },

    goto() {
      this.$store.commit("delete_tabs", this.$route.path);
      this.$router.push("noticeMsgManage");
    },

    goDetail(data) {
      console.log(data);
      let id = data.detailId;
      if (!id) {
        return;
      }
      if (data.houseCustomer == "SECONDHAND") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("sellHousebuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "SECONDHAND";
        this.$router.push({ path: "buildDetail" });
      } else if (data.houseCustomer == "SECONDHAND_MATCH") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("sellHousebuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "SECONDHAND";
        this.$router.push({
          query: {
            tabIndex: "匹配"
          },
          path: "buildDetail"
        });
      } else if (data.houseCustomer == "RENTING") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("rentHousebuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "RENTING";
        this.$router.push({ path: "rentingBuildDetail" });
      } else if (data.houseCustomer == "RENTING_MATCH") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("rentHousebuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "RENTING";
        this.$router.push({
          query: {
            tabIndex: "匹配"
          },
          path: "rentingBuildDetail"
        });
      } else if (data.houseCustomer == "SHOP_SALE") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("sellShopbuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "SHOP_SALE";
        this.$router.push({ path: "sellShopDetails" });
      } else if (data.houseCustomer == "SHOP_SALE_MATCH") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("sellShopbuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "SHOP_SALE";
        this.$router.push({
          query: {
            tabIndex: "匹配"
          },
          path: "sellShopDetails"
        });
      } else if (data.houseCustomer == "SHOP_RENTAL") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("rentShopbuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "SHOP_RENTAL";
        this.$router.push({ path: "rentShopDetails" });
      } else if (data.houseCustomer == "SHOP_RENTAL_MATCH") {
        sessionStorage.setItem("buildId", id);
        sessionStorage.setItem("rentShopbuildId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "SHOP_RENTAL";
        this.$router.push({
          query: {
            tabIndex: "匹配"
          },
          path: "rentShopDetails"
        });
      } else if (data.houseCustomer == "WANT_TO_BUY") {
        localStorage.setItem("customerId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "WANT_TO_BUY";
        this.$router.push({ path: "purchaseDetail" });
      } else if (data.houseCustomer == "WANT_TO_BUY_MATCH") {
        localStorage.setItem("customerId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "WANT_TO_BUY";
        this.$router.push({
          query: {
            tabIndex: "匹配"
          },
          path: "purchaseDetail"
        });
      } else if (data.houseCustomer == "WANT_TO_RENT") {
        localStorage.setItem("customerId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "WANT_TO_RENT";
        this.$router.push({ path: "purchaseDetail" });
      } else if (data.houseCustomer == "WANT_TO_RENT_MATCH") {
        localStorage.setItem("customerId", id);
        sessionStorage.setItem("employeeId", "");
        this.$store.state.houseType = "WANT_TO_RENT";
        this.$router.push({
          query: {
            tabIndex: "匹配"
          },
          path: "purchaseDetail"
        });
      } else if (data.houseCustomer == "NOTICE") {
        sessionStorage.setItem("noticeId", id);
        this.$router.push("/noticeDetails");
      } else if (data.houseCustomer == "CONTRACT") {
        sessionStorage.setItem("contractId", id);
        this.$router.push("/contractDetails");
      } else if (data.houseCustomer == "WARRANT") {
        sessionStorage.setItem("warrantId", id);
        this.$router.push("/warrantDetalis");
      } else if (data.houseCustomer == "APPLY") {
        sessionStorage.setItem("examineManage", id);
        sessionStorage.setItem('customerApplyId', id);
        this.$router.push("/approveManage");
      } else if (data.houseCustomer == "ENTRUST_HOUSE") {
        console.log(123);
        sessionStorage.setItem("entrustType", "委托房源");
        this.$router.push("/entrustManagement");
      } else if (data.houseCustomer == "ENTRUST_CUSTOMER") {
        sessionStorage.setItem("entrustType", "委托客源");
        this.$router.push("/entrustManagement");
      } else if (data.houseCustomer == "MAC") {
        sessionStorage.setItem("pcOrPhone", 1);
        this.$router.push("/macSet");
      } else if (data.houseCustomer == "WEB_MAC") {
        sessionStorage.setItem("pcOrPhone", 2);
        this.$router.push("/macSet");
      }
    },

    queryMessages() {
      let params = Object.assign({}, this.search);
      params["page.pageSize"] = this.pageSize;
      params["page.pageNumber"] = (this.pageNumber - 1) * this.pageSize;
      this.$post(queryMessages, params).then((res) => {
        if (res.success) {
          this.List = res.data;
          this.total = res.total;
          this.queryMessageNumberMessages();
        }
      });
    },

    queryMessageNumberMessages() {
      this.$post(queryMessageNumberMessages).then((res) => {
        if (res.success) {
          this.noticeNum = res.data.lateNumber;
          this.msgNum = res.data.noReadNumber;
        }
      });
    },

    selectAll(selection) {
      this.ids = [];
      selection.map((item) => {
        if (this.ids.indexOf(item.id) < 0 && item.status == "未读")
          this.ids.push(item.id);
      });
    },

    select(selection, row) {
      this.ids = [];
      selection.map((item) => {
        if (this.ids.indexOf(item.id) < 0 && item.status == "未读")
          this.ids.push(item.id);
      });
    },

    msgDetailShow(row, column, event) {
      this.form = row;
      this.List.map((item, index) => {
        if (item.id == this.form.id) {
          this.pageIndex = index;
          if (item.status == "未读") {
            let params = {
              ids: item.id,
            };
            this.$post(addEmployeeMessage, params).then((res) => {
              if (res.success) {
                this.queryMessages();
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
      // this.dialogVisible = true;
      this.goDetail(row);
    },

    nextPage() {
      this.pageIndex += 1;
      this.form = this.List[this.pageIndex];
      let status = this.form.status;
      let id = this.form.id;
      if (status == "未读") {
        let params = {
          ids: id,
        };
        this.$post(addEmployeeMessage, params).then((res) => {
          if (res.success) {
            this.queryMessages();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },

    addEmployeeMessage() {
      if (this.ids.length == 0) {
        this.$message.error("请至少选择一条信息");
        return;
      }
      let params = {
        ids: this.ids,
      };
      this.$post(addEmployeeMessage, params).then((res) => {
        if (res.success) {
          // this.$message.success(res.msg);
          this.ids = [];
          this.queryMessages();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //分页
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.queryMessages();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryMessages();
    },

    //表单头部颜色
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
  },
};
</script>
<style type="text/css" lang="less">
.messageManage {
  background: #ffffff;
  margin: 20px 18px;
  padding: 22px 30px 10px;
  .tab {
    display: flex;
    align-items: center;
    &-item {
      width: 100px;
      height: 36px;
      font-size: 14px;
      line-height: 36px;
      background: #f1f1f1;
      text-align: center;
      cursor: pointer;
    }
    &-active {
      background: #ff9065;
      color: #ffffff;
    }
  }
  .departpop {
    width: 170px;
    position: absolute;
    left: 0px;
    top: 41px;
    z-index: 10;
    border: 1px solid #eee;
    .tree-item {
      display: flex;
      align-items: center;
      img {
        padding-right: 10px;
      }
    }
  }
  .notice-icon {
    color: #f56c6c;
    padding-right: 6px;
  }
  .key_list {
    display: flex;
    .conditions_list_item {
      background: #f5f5f5;
      padding: 0 10px;
      display: flex;
      align-items: center;
      margin-right: 20px;
      position: relative;
      // overflow: hidden;
      cursor: pointer;
      > span {
        border-right: 1px solid #ccc;
        font-size: 12px;
        color: #5e75e6;
        padding: 4px 10px 4px 0;
      }
      .el-date-editor {
        background: #f5f5f5;
        margin-left: 10px;
        width: 310px;
        height: 30px;
        line-height: 30px;
        border: none;
        .el-range-input {
          // width: 310px;
          line-height: 30px;
          background: #f5f5f5;
          height: 30px;
          border: none;
          color: black;
          padding-left: 30px;
        }
        .el-range-separator {
          line-height: 26px;
        }
      }
      .el-select {
        margin-left: 10px;
        .el-input {
          width: 100px;
          .el-input__inner {
            width: 60px;
            height: 30px;
            border: none;
            background: #f5f5f5;
            color: black;
            padding: 0;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
      .shop {
        .el-input {
          width: 100px;
          .el-input__inner {
            width: 100px;
            height: 30px;
            border: none;
            background: #f5f5f5;
            color: black;
            padding: 0;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
    }
  }
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    text-align: center;
  }

  .key_top {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 0 30px;
    background: #fff;
    .el-input {
      width: 145px;
      height: 30px;

      .el-input-group__append,
      .el-input-group__prepend {
        padding: 0 10px;
        background: #cccccc;
        border: none;
      }

      .el-input__inner {
        border: none;
        height: 30px;
        background: #f5f5f5;
      }

      .icon-icon_sousuo {
        color: white;
      }
    }

    .add_btn {
      width: 100px;
      height: 30px;
      background: #5e75e6;
      color: white;
      outline: none;
      border: none;
    }
  }
  .el-dialog {
    width: 800px;

    .el-dialog__title {
      color: #5e75e6;
      font-size: 20px;
    }

    .el-dialog__close {
      font-size: 26px;
    }

    .el-dialog__body {
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 0;
      .leaveRequest_content {
        padding: 20px 30px 0 30px;
        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          &_div {
            flex: 1;
            display: flex;
            align-items: center;
            padding: 10px 0;
            .label {
              min-width: 100px;
              display: inline-block;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              text-align: right;
              .notice {
                color: #ff0000;
              }
            }
            .iconfont1 {
              color: #90b5ff;
            }
            .item_list {
              display: flex;
              align-items: center;
              flex-direction: row;
              flex-wrap: wrap;
              & > div {
                margin-top: 10px;
              }
            }
            .person {
              display: inline-block;
              width: 54px;
              height: 54px;
              line-height: 54px;
              margin: 0 2px;
              text-align: center;
              background: rgba(144, 181, 255, 1);
              border-radius: 50%;
              color: #ffffff;
            }
            .el-input__icon {
              line-height: 26px;
            }
            .el-input {
              width: 120px;
              height: 26px;
              margin-right: 20px;
              .el-input__inner {
                padding: 0 10px;
                height: 26px;
              }
            }
            .el-date-editor {
              width: 200px;
              .el-input__inner {
                width: 200px;
                padding: 0 30px;
                height: 26px;
                line-height: 26px;
              }
            }
          }
        }
      }
      .dialog-foot {
        text-align: right;
        margin-top: 50px;
        background: #f5f5f5;
        padding: 20px;
        .foot-cancel,
        .foot-save {
          width: 80px;
          height: 40px;
          border: none;
          outline: none;
          border-radius: 4px;
          font-size: 16px;
          color: #ffffff;
          margin-right: 20px;
        }
        .foot-cancel {
          background: #cccccc;
        }
        .foot-save {
          background: #5e75e6;
        }
      }
    }
  }

  .key_list_wrap {
    height: 90%;

    .footer_page {
      position: relative !important;
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #5e75e6;
      }

      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        border: 1px solid #ccc;
        background: white;
      }
    }
  }

  .mask .el-carousel__item {
    background: transparent;
    opacity: 1 !important;
  }
  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9;
    .close {
      width: 20px;
      position: absolute;
      top: 0;
      right: 300px;
      padding: 50px;
      z-index: 100;
    }
    .delet {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 100px;
      z-index: 100;
      height: auto !important;
    }
    .edit {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 240px;
      z-index: 100;
      height: auto !important;
    }

    .el-carousel__container {
      width: 80%;
      margin: 200px auto;
      height: 100%;
      z-index: 99;
      .el-carousel__arrow {
        font-size: 50px !important;
        padding: 20px;
        width: 100px;
        height: 100px;
      }
      // .el-carousel__arrow--left,.el-carousel__arrow--right{

      // }
    }

    .el-carousel__item {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      // min-height: 400px;
      .uploadtime {
        width: 100%;
        line-height: 24px;
        color: #fff;
        position: absolute;
        left: 100px;
        bottom: 0;
      }
      > img {
        width: 90%;
      }
    }
    .door_modle_introduced {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      padding: 0 100px;
      .introduced_toward {
        display: flex;
        flex-direction: column;
        > span {
          font-size: 14px;
          color: #ffffff;
        }

        .el-textarea {
          margin-top: 10px;
          .el-textarea__inner {
            width: 260px;
            height: 60px;
            background: #f5f5f5;
            border: 1px solid #ccc;
          }
        }
      }
      .el-select {
        margin-top: 10px;
        .el-input {
          .el-input__inner {
            padding-left: 10px !important;
            font-size: 16px !important;
            width: 100px !important;
            height: 30px !important;
            line-height: 30px !important;
            background: #f5f5f5;
            border: 1px solid #ccc !important;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
    }

    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }

    // .el-carousel__item:nth-child(2n+1) {
    //   background-color: #d3dce6;
    // }
  }
}
</style>
